import React from 'react'

/**
 * The original (English) privacy policy, hosted externally as a Google Doc.
 */
export const PRIVACY_POLICY_URL =
  'https://docs.google.com/document/d/e/2PACX-1vSh6Tk0dYt7Yk16jTz4ac5If4L1n-HemLxs-6svuC7CsMrYlAt6tASQNhw3E7Jbkw/pub'

/**
 * Path of the privacy-policy Google Doc, reused to build the Google Translate
 * proxy URL (the host changes, the path stays the same).
 */
const PRIVACY_POLICY_DOC_PATH =
  'document/d/e/2PACX-1vSh6Tk0dYt7Yk16jTz4ac5If4L1n-HemLxs-6svuC7CsMrYlAt6tASQNhw3E7Jbkw/pub'

/**
 * The privacy policy link for a given language. English keeps the original
 * document; every other language points to a Google Translate proxy of it,
 * matching the selected language. `language` is the selected-language code
 * (e.g. "ja", "zh-HK", "he"), which Google Translate accepts as-is in
 * `_x_tr_tl`.
 */
export const getPrivacyPolicyUrl = (language: string): string => {
  if (language === 'en') {
    return PRIVACY_POLICY_URL
  }
  const params = `_x_tr_sl=en&_x_tr_tl=${language}&_x_tr_hl=en&_x_tr_pto=wapp`
  return `https://docs-google-com.translate.goog/${PRIVACY_POLICY_DOC_PATH}?${params}`
}

type Chunks = React.ReactNode

/**
 * Rich-text element handlers shared by every translated T&C body. The T&C
 * copy lives in `intl/copy/<locale>.json` as ICU messages that use these tags
 * (`<p>`, `<ul>`, `<li>`, `<br></br>`, `<privacy>`) so translators only touch
 * the prose, never the markup or the privacy-policy URL. The `<privacy>` link
 * target is resolved per language so it opens a Google-translated copy of the
 * policy in the respondent's language.
 */
export const getTermsRichTextElements = (language: string) => ({
  p: (chunks: Chunks) => (
    <>
      {chunks}
      <br />
      <br />
    </>
  ),
  ul: (chunks: Chunks) => <ul>{chunks}</ul>,
  li: (chunks: Chunks) => <li>{chunks}</li>,
  br: () => <br />,
  privacy: (chunks: Chunks) => (
    <a href={getPrivacyPolicyUrl(language)} rel="noreferrer" target="_blank">
      {chunks}
    </a>
  )
})
